module.exports = __webpack_public_path__ + "img/b532d98.png";